import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
var log = logFactory('splitio-producer:split-changes');
import splitChangesFetcher from '../fetcher/SplitChanges';
import parseSegments from '../../engine/parser/segments';
import { SplitError } from '../../utils/lang/Errors';
import thenable from '../../utils/promise/thenable';
function computeSplitsMutation(entries) {
  var computed = _reduceInstanceProperty(entries).call(entries, function (accum, split) {
    if (split.status === 'ACTIVE') {
      accum.added.push([split.name, _JSON$stringify(split)]);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
      try {
        for (var _iterator = _getIterator(parseSegments(split.conditions)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var segmentName = _step.value;
          accum.segments.add(segmentName);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      accum.removed.push(split.name);
    }
    return accum;
  }, {
    added: [],
    removed: [],
    segments: new _Set()
  });
  computed.segments = _toConsumableArray(computed.segments);
  return computed;
}
function SplitChangesUpdaterFactory(context) {
  var isNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _context$getAll = context.getAll(),
    settings = _context$getAll[context.constants.SETTINGS],
    readiness = _context$getAll[context.constants.READINESS],
    storage = _context$getAll[context.constants.STORAGE],
    metricCollectors = _context$getAll[context.constants.COLLECTORS];
  var splitsEventEmitter = readiness.splits;
  var startingUp = true;
  var readyOnAlreadyExistentState = true;
  return function SplitChangesUpdater() {
    var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    function splitChanges(since) {
      log.debug("Spin up split update using since = ".concat(since));
      var fetcherPromise = splitChangesFetcher(settings, since, startingUp, metricCollectors, isNode).then(function (splitChanges) {
        startingUp = false;
        var mutation = computeSplitsMutation(splitChanges.splits);
        log.debug("New splits ".concat(mutation.added.length));
        log.debug("Removed splits ".concat(mutation.removed.length));
        log.debug("Segment names collected ".concat(mutation.segments)); // Write into storage

        return _Promise.all([storage.splits.addSplits(mutation.added), storage.splits.removeSplits(mutation.removed), storage.splits.setChangeNumber(splitChanges.till), storage.segments.registerSegments(mutation.segments)]).then(function () {
          if (since !== splitChanges.till || readyOnAlreadyExistentState) {
            readyOnAlreadyExistentState = false;
            splitsEventEmitter.emit(splitsEventEmitter.SDK_SPLITS_ARRIVED);
          }
        });
      })["catch"](function (error) {
        if (!(error instanceof SplitError)) {
          _setTimeout(function () {
            throw error;
          }, 0);
          startingUp = false; // Stop retrying.
        }
        log.warn("Error while doing fetch of Splits ".concat(error));
        if (startingUp && settings.startup.retriesOnFailureBeforeReady > retry) {
          var _context;
          retry += 1;
          log.info(_concatInstanceProperty(_context = "Retrying download of splits #".concat(retry, ". Reason: ")).call(_context, error));
          return SplitChangesUpdater(retry);
        } else {
          startingUp = false;
        }
        return false;
      }); // After triggering the requests, if we have cached splits information let's notify that.

      if (startingUp && storage.splits.checkCache()) splitsEventEmitter.emit(splitsEventEmitter.SDK_SPLITS_CACHE_LOADED);
      return fetcherPromise;
    } // @TODO check why e2e tests take so much time when sync storage result is not handled in a promise

    var since = storage.splits.getChangeNumber();
    var sincePromise = thenable(since) ? since.then(splitChanges) : _Promise.resolve(since);
    return sincePromise.then(splitChanges);
  };
}
export default SplitChangesUpdaterFactory;